import { convertMillisecondsToUTCDate } from 'utils/convertTime';

export const formatProjectMetadataDates = (obj: object): Record<string, string> => {
  const result = {};
  for (const key in obj) {
    const value = obj[key];

    if (/date/i.test(key) && value) {
      result[key] = convertMillisecondsToUTCDate(value);
    } else {
      result[key] = value;
    }
  }

  return result;
};
